module.exports = __webpack_public_path__ + "static/img/zcbg@1x.5a480d88.png";